import { render, staticRenderFns } from "./issue_due_date.vue.js?vue&type=template&id=194159b8!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_due_date.vue?vue&type=template&id=194159b8"
import script from "./issue_due_date.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_due_date.vue?vue&type=script&lang=js"
export * from "./issue_due_date.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_due_date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('194159b8')) {
      api.createRecord('194159b8', component.options)
    } else {
      api.reload('194159b8', component.options)
    }
    module.hot.accept("./issue_due_date.vue.js?vue&type=template&id=194159b8!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_due_date.vue?vue&type=template&id=194159b8", function () {
      api.rerender('194159b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "boards/components/issue_due_date.vue"
export default component.exports